import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import withPrefersReducedMotion, {
    type WithoutPrefersReducedMotion,
    type WithPrefersReducedMotionProps,
} from "#data-access/with-prefers-reduced-motion.tsx";

type SkeltonProps = {
    width: number | string;
    height: number | string;
};

export const Skeleton = ({width, height}: SkeltonProps): React.ReactElement => (
    <div style={{width, height}} className={css(styles.skeleton)} />
);

type ShimmerOwnProps = {
    children: React.ReactNode;
};
type ShimmerProps = ShimmerOwnProps & WithPrefersReducedMotionProps;

const Shimmer = ({
    children,
    prefersReducedMotion,
}: ShimmerProps): React.ReactElement =>
    // @ts-expect-error - TS2322 - Type 'string | number | boolean | ReactFragment | Element | null | undefined' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
    prefersReducedMotion ? (
        children
    ) : (
        <div className={css(styles.shimmer)}>{children}</div>
    );

const keyframeAnimation = {
    "0%": {opacity: 0.4},
    "50%": {opacity: 1},
    "100%": {opacity: 0.4},
} as const;

const styles = StyleSheet.create({
    shimmer: {
        // @ts-expect-error - TS2322 - Type '{ readonly "0%": { readonly opacity: 0.4; }; readonly "50%": { readonly opacity: 1; }; readonly "100%": { readonly opacity: 0.4; }; }' is not assignable to type 'AnimationName | undefined'.
        animationName: keyframeAnimation,
        animationDuration: "2s",
        animationIterationCount: "infinite",
    },
    skeleton: {
        background: color.offBlack8,
    },
});

type ExportProps = WithoutPrefersReducedMotion<
    JSX.LibraryManagedAttributes<
        typeof Shimmer,
        React.ComponentProps<typeof Shimmer>
    >
>;

export default withPrefersReducedMotion(
    Shimmer,
) as React.ComponentType<ExportProps>;
